var $j = jQuery.noConflict();

$j(document).ready(function() {
	$j(".animate").each(function() {
		ScrollTrigger.create({
			trigger: this,
			start: "top bottom",
			end: "bottom top",
			onEnter: () => $j(this).addClass('animated'),
			onLeave: () => {
				if(!$j(this).hasClass('animate-once') && !$j(this).hasClass('animate-down-only')) {
					$j(this).removeClass('animated');
				}
			},
			onEnterBack: () => $j(this).addClass('animated'),
			onLeaveBack: () => {
				if(!$j(this).hasClass('animate-once')) {
					$j(this).removeClass('animated');
				}
			},
		});
		
		$j(".wp-block-pullquote").each(function() {
			ScrollTrigger.create({
				trigger: this,
				start: "top 80%",
				onEnter: () => $j(this).addClass("animated"),
			})
		});
	});
	
	ScrollTrigger.create({
		trigger: "#gallery",
		start: "top 80%",
		// end: "top 30%",
		onEnter: () => $j("#gallery .cell").addClass("animated"),
		onLeaveBack: () => $j("#gallery .cell").removeClass("animated")
	});
	
	ScrollTrigger.create({
		trigger: "#experience .content__wrapper",
		start: "top 80%",
		// end: "top 30%",
		onEnter: () => $j("#experience .content__wrapper .cell").addClass("animated"),
		onLeaveBack: () => $j("#experience .content__wrapper .cell").removeClass("animated")
	});
	
	// Close off-canvas menu when anchor link is clicked
	$j('#off-canvas .close-on-click a').on('click', function() {
		$j('#off-canvas').foundation('close');
	});
});

if (window.location.hash) {
	var hash = window.location.hash;
	
	if ($j(hash).length) {
		$j('html, body').animate({
			scrollTop: $j(hash).offset().top
		}, 900, 'swing');
	}
}

$j('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
	// On-page links
	if (
		location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
		&& 
		location.hostname == this.hostname
	) {
		// Figure out element to scroll to
		var target = $j(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		// Does a scroll target exist?
		if (target.length) {
			// Only prevent default if animation is actually gonna happen
			event.preventDefault();
			$j('html, body').animate({
				scrollTop: target.offset().top
			}, 900, function() {
				// Callback after animation
				// Must change focus!
				var $target = $j(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
			});
		}
	}
});

// Play video on reveal window open
$j(document).on('open.zf.reveal', '[data-reveal]', function() {
	var video = this.querySelector('iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"], video');
	
	if (video) {
		if (video.tagName.toLowerCase() === 'video') {
			video.play();
		}
	}
	// todo: add iframe YouTube/Vimeo play function
});

// Stops iframe videos in reveal window from playing on reveal window close
$j(document).on('closed.zf.reveal', '[data-reveal]', function() {
	var video = this.querySelector('iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"], video');
	
	if (video) {
		if (video.tagName.toLowerCase() === 'video') {
			video.pause();
		}
		// todo: add iframe YouTube/Vimeo pause function
		// if( iframe.length > 0 ) {
		// 	var isYt = $j('#'+id+' .video__wrapper > div').hasClass('youtube-player') ? true : false;
		// 	if( isYt ) {
		// 		$j(iframe).each(function() {
		// 			this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		// 		});
		// 	} else {
		// 		$j(iframe).each(function() {
		// 			var src = this.src;
		// 			this.src = '';
		// 			this.src = src;
		// 		});
		// 	}
		// }
	}
});